import { render, staticRenderFns } from "./alarmnew.vue?vue&type=template&id=2c6cb82c&scoped=true&"
import script from "./alarmnew.vue?vue&type=script&lang=js&"
export * from "./alarmnew.vue?vue&type=script&lang=js&"
import style0 from "./alarmnew.vue?vue&type=style&index=0&id=2c6cb82c&lang=less&scoped=true&"
import style1 from "./alarmnew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6cb82c",
  null
  
)

export default component.exports